import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { connect } from 'react-redux';
import { Grid, TableRow, TableBody, Table, TableCell, TableHead, Button, Icon, Card, Typography, LinearProgress } from 'material-ui';
import jsPDF from 'jspdf';
import moment from 'moment';
import icon_excel from '../../resources/images/icon_excel.png';
import icon_pdf from '../../resources/images/icon_pdf.png';
import { AGE_RANGES, TRANSPORTS, CONSULT_REASONS, TRAVEL_REASON, ACCOMODATION } from '../../config/constants';
import SimpleBarChart from '../chartComponents/SimpleBarChart';
import StackedBarChart from '../chartComponents/StackedBarChart';
import ReactExport from "react-data-export";
import ExcelColumn from 'react-data-export/dist/ExcelPlugin/elements/ExcelColumn';
import { loadData } from '../../controllers/results/peopleByCountry';
import { getFilterText, setHeader, setGraphic, setTable, setFooter } from '../../utils/utils';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class PeopleByCountry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            loading: true,
            title: "Gráfica de distribución de persoas por país de procedencia",
            filename: "distribución_por_país_" + moment().format('DD-MM-YYYY'),
            data: [],
            excellData: {
                columns: [],
                data: []
            },
            total: 0,
            headers: [{
                label: "País de orixe",
                key: "country_name"
            }, {
                label: "Nº de persoas",
                key: "personas"
            }],
            advancedFilter: {
                name: "",
                value: ""
            },
            vertical: false,
            advancedFilters: [{
                name: "age",
                label: "Idades",
                values: AGE_RANGES,
                fieldName: "text",
                fieldValue: "value"
            }, {
                name: "transport",
                label: "Transporte",
                values: TRANSPORTS,
                fieldName: "text",
                fieldValue: "value"
            }, {
                name: "consult_reason",
                label: "Motivo da consulta",
                values: CONSULT_REASONS,
                fieldName: "text",
                fieldValue: "value"
            }, {
                name: "travel_reason",
                label: "Motivación da viaxe",
                values: TRAVEL_REASON,
                fieldName: "text",
                fieldValue: "value"
            }, {
                name: "overnight_accomodation",
                label: "Aloxamento",
                values: ACCOMODATION,
                fieldName: "text",
                fieldValue: "value"
            }]
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) {
            this.loadData();
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const { sessionData } = this.props.main;
        const { filter } = this.props;
        let { data } = this.state;
        data = await loadData(sessionData, filter);
        this.setState(data);
        this.setState({ loading: false });
    }

    updateAdvancedFilter = (value, name) => {
        const { filter: { advancedFilter } } = this.state;
        if ((advancedFilter.name === name && advancedFilter.value === value) || (advancedFilter.name === name && value === "-1")) {
            advancedFilter.name = "";
            advancedFilter.value = ""
        } else {
            advancedFilter.name = name;
            advancedFilter.value = value;
        }
        this.setState({ advancedFilter: advancedFilter });
    }

    setLogoutAlert = (open) => {
        this.setState({ open: open });
    }

    exportPdf = async () => {
        this.setState({ downloading: true });
        try {
            const { offices, municipalities } = this.props.main;
            const { filter } = this.props;
            const { title } = this.state;
            let doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
            let filter_text = getFilterText(filter, municipalities, offices);
            setHeader(doc, title, `Período: ${filter.from} a ${filter.to} ${filter_text}`);
            await setGraphic(doc, `graphic`);
            await setTable(doc, `tableAux`);
            setFooter(doc, 1, 1);
            doc.save(this.state.filename);
        } catch (err) {
            console.error(err);
        }
        this.setState({ downloading: false });
    }

    setVertical = () => {
        this.setState({ vertical: !this.state.vertical });
    }

    render() {
        const { data, total, advancedFilter, vertical, filename, excellData, loading, downloading } = this.state;
        let buildData;
        if (data){
            buildData = data.sort((a,b) => (a.personas > b.personas) ? -1 : ((b.personas > a.personas) ? 1 : 0));
        }
        return (
            <Fragment>
                <Grid item xs={12} style={{ marginTop: '-8.5em' }}>
                    <Grid container spacing={16}>
                        <Grid item xs={8}>
                            {/* <Typography variant="subtitle" id="title">{title}</Typography> */}
                        </Grid>

                        <Grid item xs={4} >
                            <div style={{ flexDirection: 'column', alignItems: 'right' }}>
                                <Button disabled={downloading} style={{
                                    backgroundColor: "#DDD",
                                    marginTop: '0.5em',
                                    marginRight: '1em',
                                    float: 'right'
                                }} onClick={this.exportPdf}>
                                    Exportar pdf<Icon>
                                        <img src={icon_pdf} alt="Exportar como pdf" />
                                    </Icon>

                                </Button>
                                <ExcelFile filename={filename} element={
                                    <Button style={{
                                        backgroundColor: "#DDD",
                                        marginTop: '0.5em',
                                        marginRight: '1em',
                                        float: 'right'
                                    }}>
                                        Exportar excel <Icon>
                                            <img src={icon_excel} alt="Exportar como excel" />
                                        </Icon>
                                    </Button>
                                }>
                                    <ExcelSheet data={excellData.data} name="Estadísticas por comunidade">
                                        {excellData.columns.map(column => {
                                            return (<ExcelColumn key={`${excellData.key}_${column.value}`} label={column.label} value={column.value} />);
                                        })}
                                    </ExcelSheet>
                                </ExcelFile>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                {loading ?
                    <Card style={{ width: '100%' }}>
                        <Typography variant="headline" component="h4">Cargando resultados...</Typography>
                        <LinearProgress />
                    </Card>
                    :
                    <React.Fragment>
                        <Grid item xs={12} md={9} xl={8}>
                            {advancedFilter.name === "" && advancedFilter.value === "" ?
                                <SimpleBarChart
                                    data={buildData}
                                    dataKeyX="country_name"
                                    dataKeyY="personas"
                                    typeX="category"
                                    typeY="number"
                                    vertical={vertical}
                                    minHeight={580}
                                    barColor="#8884d8" />
                                :
                                <StackedBarChart
                                    data={data}
                                />
                            }
                        </Grid>
                        <Grid item xs={12} md={3} xl={4} style={{ textAlign: 'center' }}>
                            {data.length > 0 && <Button onClick={this.setVertical}>{vertical === true ? 'Vista vertical' : 'Vista horizontal'}</Button>}
                            <div style={{ margin: '0 1em' }}>
                                <Table id="tableAux">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ padding: '3px 0px 3px 2px' }}>País</TableCell>
                                            <TableCell style={{ padding: '3px 0px 3px 2px', textAlign: 'right' }}>Visitantes</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((item) => {
                                            return (
                                                <TableRow style={{ height: '40px' }} key={`pais_${item.origin}`}>
                                                    <TableCell style={{ padding: '3px 0px 3px 2px' }}>{item.country_name}</TableCell>
                                                    <TableCell style={{ padding: '3px 0px 3px 2px', textAlign: 'right' }}>{item.personas}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        <TableRow style={{ fontWeight: 'bold' }}>
                                            <TableCell style={{ padding: '3px 0px 3px 2px' }}>Total</TableCell>
                                            <TableCell style={{ padding: '3px 0px 3px 2px', textAlign: 'right' }}>{total}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </div>
                        </Grid>
                    </React.Fragment>
                }
            </Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

const mapStateToProps = (state) => ({
    main: state.main
});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleByCountry);



// WEBPACK FOOTER //
// ./src/components/SurveyResults/PeopleByCountry.js